<template>
    <modal-dialog :hide-close="true">
        <h3 class="modal-title text-center" id="modal-title">
            Foto do documento
        </h3>
        <span v-if="isLoading" class="m-y-xl d-block"><i class="fa fa-circle-o-notch fa-spin"></i> Carregando...</span>
        <div class="area">
            <div id="recognition-modal-container">
                <p class="recognition-info" v-if="!isLoading">
                    Envie uma foto de sua documentação para validação.
                    Posicione-se em um ambiente com boa luminosidade sem interferência de luz direta que possa ofuscar
                    ou reduzir a eficácia da sua identificação.
                    A foto deve ser enviada segurando o documento (RG ou CNH) ao lado de seu rosto.
                </p>
            </div>
            <video ref="webCamera" autoplay muted playsinline style="width: auto; height: 350px;"
                   v-show="(!img) && !isLoading" title="Vídeo da sua câmera"></video>
            <input type="hidden" id="base_img" name="base_img" v-model="img"/>
            <img id="imagemTirada" v-if="img && !isLoading" :src="img" height="350" alt="Sua foto capturada para perfil">
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary m-r-lg" @click="sendSnapShot" :disabled="isLoading" v-if="img">Salvar
            </button>
            <button class="btn btn-default" @click="takePhoto" :disabled="isLoading" v-if="!img">Tirar foto</button>
            <button class="btn btn-default" @click="renewPhoto" :disabled="isLoading" v-if="img">Tirar nova foto
            </button>
        </div>
    </modal-dialog>
</template>

<script>
    import axios from 'axios';
    import {getBaseSgpUrl} from "../../../scripts/apiService/ApiService";
    import ModalDialog from "../../base/Modal";

    export default {
        name: 'takeCandidateDocumentPhoto',
        components: {ModalDialog},
        props: ['finishFunction', 'nativeProctoring'],
        data() {
            let variables = this.$store.state.onlineTest.configs.variables;
            return {
                isLoading: true,
                img: null,
                candidate_document: variables.candidate_photo,
                item_generated: variables.item_generated_id,
                candidate_id: variables.candidate_key,
                cameraStream: null,
            }
        },
        methods: {
            takePhoto() {
                let video = this.$refs.webCamera;

                let canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                this.img = canvas.toDataURL('image/jpeg');
            },
            renewPhoto() {
                this.img = null;
            },
            sendSnapShot() {
                let candidate_document = this.img;
                let candidate_id = this.candidate_id;
                let item_generated = this.item_generated;

                let url = '{baseUrl}api/v1/tm/rest/candidatedocument/'
                    .replace('{baseUrl}', getBaseSgpUrl())
                let data = {
                    candidate_document: candidate_document,
                    item_generated: item_generated,
                    candidate_id: candidate_id
                };
                let component = this;

                this.isLoading = true;

                axios.post(url, data).then(() => {
                    this.cameraStream.getTracks().forEach(function(track) {
                        track.stop();
                    });
                    component.finishFunction();
                }).catch(function () {
                    alert("Houve um erro ao salvar a sua foto.");
                    component.isLoading = false;
                });
            },
            loadCamera() {
                let video = this.$refs.webCamera;
                let component = this;
                if (video) {
                    if (navigator.mediaDevices.getUserMedia) {
                        navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'user'}})
                            .then((stream) => {
                                this.cameraStream = stream;
                                video.srcObject = stream;
                                component.isLoading = false;
                            })
                            .catch(function () {
                                alert("Habilite sua câmera e recarregue a página.");
                                location.reload();
                            });
                    }
                }
            }
        },
        beforeUnmount() {
            if (this.cameraStream){
                this.cameraStream.getTracks().forEach(function(track) {
                    track.stop();
                });
            }
        },
        mounted() {
            this.loadCamera();
        }
    }
</script>

<style scoped>
    .modal-mask-transparent {
        background-color: rgba(0, 0, 0, 0.7) !important;
    }

    @media (max-width: 768px) and (orientation: portrait) {
        .modal-container {
            width: 80% !important;
        }

        .modal-wrapper {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
        }
    }

    @media (max-width: 768px) and (orientation: landscape) {
        .modal-container {
            width: 80% !important;
        }

        .modal-wrapper {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
        }

        .area video {
            height: 225px !important;
        }

        .modal-header {
            padding-bottom: 5px;
            padding-top: 5px;
        }

        .modal-body {
            padding-top: 0px !important;
        }

        .area img {
            max-width: 100% !important;
            height: 225px !important;
        }
    }
</style>